/*
 * @Author: zhaoshuai11
 * @Date: 2025-11-17 16:07:54
 * @LastEditors: zhaoshuai11
 * @LastEditTime: 2025-12-02 15:41:34
 * @Description:
 *
 */
import { isMasterApp } from 'hel-iso';
import Vue from 'vue';
import { LIB_NAME } from './configs/subApp';
import { libReady } from 'hel-lib-proxy';
// import { preFetchLib } from 'hel-micro';

if (Vue.config) {
  Vue.config.productionTip = false;
}
import Config from '@/components/business/intelligentAssistant/utils/apolloConfig';
// 获取apollo配置信息

(async function () {
  const configExample = new Config();
  await configExample.requestComplete; // 等待配置加载
  Vue.prototype.$abilityConfig = configExample.ABILITY || {};
  Vue.prototype.$trainingConfig = configExample.TRAINING || {};
  window.$abilityConfig = configExample.ABILITY || {};
  window.$trainingConfig = configExample.TRAINING || {};
  // const enableCustom = false;
  // await preFetchLib('hel-tpl-remote-vue-comps2');

  const libProperties = await import('./entrance/libProperties');
  // 注意此处传递的是 default
  libReady(LIB_NAME, libProperties.default);

  // 非子应用时（即不是被别的模块触发载入的情况），自己挂载渲染节点，方便本地调试
  // 可根据项目实际情况控制是否载入 loadApp 文件
  // eslint-disable-next-line
  if (isMasterApp()) {
    await import('./loadApp');
  }
})().catch(console.error);
